import React from "react"
import {
  Box,
  Container,
  Typography,
  Paper
} from "@mui/material"
import { LoginForm } from "../../components"
import styled from "styled-components"

const StyledPage = styled(Box)`
  flex: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

const StyledHeader = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem;
  & h1 {
    font-size: 3.5rem;
  }
`

export default function LoginPage() {
  return (
    <StyledPage>
      <Container maxWidth="lg">
        <StyledHeader>
          <Typography variant="h1" component="h1">
            Login
          </Typography>
        </StyledHeader>
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center" 
          flex={1}
          py={4}
        >
          <LoginForm />
        </Box>
      </Container>
    </StyledPage>
  )
}